import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { RequestTokenService } from "../../../../../../services/request-token.service";
import { environment } from "../../../../../../environments/environment";
import { PerfilUsuarioSignature } from "../../models/signature/perfilUsuarioSignature";
import { AtualizarSenhaPerfilUsuarioSignature } from "../../models/signature/AtualizarSenhaPerfilUsuarioSignature";

const API_URL = `${environment.apiUrl}v10/PerfilUsuario`;

@Injectable({
  providedIn: 'root'
})

export class PerfilUsuarioService {

  constructor(private http: HttpClient,
    private requestToken: RequestTokenService
  ) {}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }

  public CarregaImagemPerfilUsuario(): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/CarregaImagemPerfilUsuario`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public CarregarDadosPerfilUsuario(): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/CarregarDadosPerfilUsuario`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public AtualizarDadosPerfilUsuario(signature: PerfilUsuarioSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/AtualizarDadosPerfilUsuario`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public ValidarSenhaAtualPerfilUsuario(signature: AtualizarSenhaPerfilUsuarioSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/ValidarSenhaAtualPerfilUsuario`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }
 }
